import { TOP_BAR_NOTIFICATION_BELL_SRC } from './constants';

interface NotificationChipProps {
  isGuardian: boolean;
}

/** Placeholder notification affordance (design chrome; not wired to real notifications yet). */
export function NotificationChip({ isGuardian }: NotificationChipProps) {
  return (
    <div className="relative flex items-center" aria-hidden={isGuardian ? undefined : true}>
      <div
        className={`flex size-[37px] shrink-0 items-center justify-center rounded-[24px] bg-white ${
          isGuardian ? 'shadow-[0px_4px_4px_0px_rgba(37,49,72,0.05)]' : 'shadow-card'
        }`}
      >
        <img
          src={TOP_BAR_NOTIFICATION_BELL_SRC}
          alt=""
          className={`object-contain ${isGuardian ? 'size-3' : 'size-4'}`}
        />
      </div>
      <span className="absolute -right-px -top-px flex size-3 items-center justify-center rounded-[6px] bg-[#f5846a] text-[8px] font-semibold leading-none text-white">
        1
      </span>
    </div>
  );
}
